import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageCroppedEvent, ImageCropperComponent, base64ToFile } from 'ngx-image-cropper';
import { SnackBarService } from '../../services/snackBar.service';

export interface CropperSettings {
  aspectRatio: number;
  resizeToWidth: number;
  roundCropper: boolean;
}

export interface CropperConfig extends CropperSettings {
  image: File;
}

@Component({
  selector: 'app-crop-image',
  templateUrl: './crop-image.component.html',
  styleUrls: ['./crop-image.component.scss']
})
export class CropImageComponent {
  public loading: boolean = true; // if true a loading message will be displayed instead of an image
  public containWithinAspectRatio: boolean = false;

  private file!: File | null;
  private croppedImage: any = '';

  @ViewChild('cropper') private cropper!: ImageCropperComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CropperConfig,
    public dialogRef: MatDialogRef<ImageCropperComponent>,
    private snackBarService: SnackBarService
  ) {}

  public imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64;
    this.file = new File([base64ToFile(this.croppedImage)], this.cropper.imageFile.name, {
      type: this.cropper.imageFile.type
    });
  }

  /**
   * .ngx-ic-topright, .ngx-ic-topleft,.ngx-ic-bottomright,.ngx-ic-bottomleft are
   *  the classes of  inner Elements of ImageCropperComponent. They describe corner resize handle.
   *  ImageCropperComponent is an external component.
   *
   * .hidden class makes an element invisible.
   */
  public cropperReady(): void {
    this.loading = false;
    if (this.data.roundCropper) {
      document.querySelector('.ngx-ic-topright')?.classList.add('hidden');
      document.querySelector('.ngx-ic-topleft')?.classList.add('hidden');
      document.querySelector('.ngx-ic-bottomright')?.classList.add('hidden');
      document.querySelector('.ngx-ic-bottomleft')?.classList.add('hidden');
    }
  }

  public onContainWithinAspectRatio(): void {
    this.containWithinAspectRatio = !this.containWithinAspectRatio;
  }

  public loadImageFailed(): void {
    this.snackBarService.showError('Nie udało się wczytać obrazu');
    this.dialogRef.close({ croppedFile: null });
  }

  public onCancel(): void {
    this.dialogRef.close({ croppedFile: null });
  }

  public onSubmit(): void {
    this.dialogRef.close({ croppedFile: this.file });
  }
}
